import { render, staticRenderFns } from "./DeliverySummary.vue?vue&type=template&id=0311fab4&scoped=true&"
import script from "./DeliverySummary.vue?vue&type=script&lang=js&"
export * from "./DeliverySummary.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySummary.vue?vue&type=style&index=0&id=0311fab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311fab4",
  null
  
)

export default component.exports